import { Alert } from '@mui/material'
import React from 'react'
import { useQuery } from 'react-query'
import useLocales from 'src/hooks/useLocales'
import axiosInstance from 'src/utils/axios'

function HealthCheck() {
    const { translate } = useLocales()
    const healthQuery = useQuery(['app_health'], () => axiosInstance.get('health'), {
        retry: 0
    })

    if (healthQuery.isLoading) {
        return <></>
    }

    if (healthQuery.isError) {
        return (
            <Alert severity='error' variant='filled' sx={{ borderRadius: 0, px: 2 }}>{translate('serviceDown')}</Alert>
        )
    }
    return <></>

}

export default HealthCheck